
export const ACTION_TYPES = {

    ARBORIST_LOGIN_REQUEST: 'ARBORIST_LOGIN_REQUEST',
    ARBORIST_LOGIN_SUCCESS: "ARBORIST_LOGIN_SUCCESS",
    ARBORIST_LOGIN_FAILED: "ARBORIST_LOGIN_FAILED",

    ARBORIST_LOGOUT_REQUEST: 'ARBORIST_LOGOUT_REQUEST',
    ARBORIST_LOGOUT_SUCCESS: "ARBORIST_LOGOUT_SUCCESS",
    ARBORIST_LOGOUT_FAILED: "ARBORIST_LOGOUT_FAILED",

    ARBORIST_GENERATECODE_REQUEST: 'ARBORIST_GENERATECODE_REQUEST',
    ARBORIST_GENERATECODE_SUCCESS: "ARBORIST_GENERATECODE_SUCCESS",
    ARBORIST_GENERATECODE_FAILED: "ARBORIST_GENERATECODE_FAILED",

    ARBORIST_FORGOTPASSWORD_REQUEST: 'ARBORIST_FORGOTPASSWORD_REQUEST',
    ARBORIST_FORGOTPASSWORD_SUCCESS: "ARBORIST_FORGOTPASSWORD_SUCCESS",
    ARBORIST_FORGOTPASSWORD_FAILED: "ARBORIST_FORGOTPASSWORD_FAILED",

    FETCH_ARBOR_PROFILE_REQUEST: 'FETCH_ARBOR_PROFILE_REQUEST',
    FETCH_ARBOR_PROFILE_SUCCESS: 'FETCH_ARBOR_PROFILE_SUCCESS',
    FETCH_ARBOR_PROFILE_FAILED : 'FETCH_ARBOR_PROFILE_FAILED',

    EDIT_ARBOR_PROFILE_REQUEST: 'EDIT_ARBOR_PROFILE_REQUEST',
    EDIT_ARBOR_PROFILE_SUCCESS: 'EDIT_ARBOR_PROFILE_SUCCESS',
    EDIT_ARBOR_PROFILE_FAILED : 'EDIT_ARBOR_PROFILE_FAILED',

    ARBORIST_RESETPASSWORD_REQUEST: 'ARBORIST_RESETPASSWORD_REQUEST',
    ARBORIST_RESETPASSWORD_SUCCESS: "ARBORIST_RESETPASSWORD_SUCCESS",
    ARBORIST_RESETPASSWORD_FAILED: "ARBORIST_RESETPASSWORD_FAILED",

    ADD_CLIENT_REQUEST: 'ADD_CLIENT_REQUEST',
    ADD_CLIENT_SUCCESS: 'ADD_CLIENT_SUCCESS',
    ADD_CLIENT_FAILED: 'ADD_CLIENT_FAILED',

    FETCH_CLIENT_REQUEST: 'FETCH_CLIENT_REQUEST',
    FETCH_CLIENT_SUCCESS: 'FETCH_CLIENT_SUCCESS',
    FETCH_CLIENT_FAILED: 'FETCH_CLIENT_FAILED',

    EDIT_CLIENT_REQUEST: 'EDIT_CLIENT_REQUEST',
    EDIT_CLIENT_SUCCESS: 'EDIT_CLIENT_SUCCESS',
    EDIT_CLIENT_FAILED: 'EDIT_CLIENT_FAILED',

    SET_CLIENT_REQUEST: 'SET_CLIENT_REQUEST',
    SET_CLIENT_SUCCESS: 'SET_CLIENT_SUCCESS',
    SET_CLIENT_FAILED: 'SET_CLIENT_FAILED',

    DELETE_CLIENT_REQUEST: 'DELETE_CLIENT_REQUEST',
    DELETE_CLIENT_SUCCESS: 'DELETE_CLIENT_SUCCESS',
    DELETE_CLIENT_FAILED: 'DELETE_CLIENT_FAILED',

    FETCH_CLIENT_TYPES_REQUEST: 'FETCH_CLIENT_TYPES_REQUEST',
    FETCH_CLIENT_TYPES_SUCCESS: 'FETCH_CLIENT_TYPES_SUCCESS',
    FETCH_CLIENT_TYPES_FAILED:  'FETCH_CLIENT_TYPES_FAILED',

    ADD_PROPERTY_REQUEST: 'ADD_PROPERTY_REQUEST',
    ADD_PROPERTY_SUCCESS: 'ADD_PROPERTY_SUCCESS',
    ADD_PROPERTY_FAILED: 'ADD_PROPERTY_FAILED',

    FETCH_PROPERTY_REQUEST: 'FETCH_PROPERTY_REQUEST',
    FETCH_PROPERTY_SUCCESS: 'FETCH_PROPERTY_SUCCESS',
    FETCH_PROPERTY_FAILED: 'FETCH_PROPERTY_FAILED',

    FETCH_CLIENT_PROPERTY_REQUEST: 'FETCH_CLIENT_PROPERTY_REQUEST',
    FETCH_CLIENT_PROPERTY_SUCCESS: 'FETCH_CLIENT_PROPERTY_SUCCESS',
    FETCH_CLIENT_PROPERTY_FAILED: 'FETCH_CLIENT_PROPERTY_FAILED',
    

    SET_PROPERTY_REQUEST: 'SET_PROPERTY_REQUEST',
    SET_PROPERTY_SUCCESS: 'SET_PROPERTY_SUCCESS',
    SET_PROPERTY_FAILED: 'SET_PROPERTY_FAILED',

    EDIT_PROPERTY_REQUEST: 'EDIT_PROPERTY_REQUEST',
    EDIT_PROPERTY_SUCCESS: 'EDIT_PROPERTY_SUCCESS',
    EDIT_PROPERTY_FAILED: 'EDIT_PROPERTY_FAILED',

    DELETE_PROPERTY_REQUEST: 'DELETE_PROPERTY_REQUEST',
    DELETE_PROPERTY_SUCCESS: 'DELETE_PROPERTY_SUCCESS',
    DELETE_PROPERTY_FAILED: 'DELETE_PROPERTY_FAILED',

    SET_CLIENT_CONTACT_REQUEST: 'SET_CLIENT_CONTACT_REQUEST',
    SET_CLIENT_CONTACT_SUCCESS: 'SET_CLIENT_CONTACT_SUCCESS',
    SET_CLIENT_CONTACT_FAILED: 'SET_CLIENT_CONTACT_FAILED',

    SAVE_REPORT_REQUEST: 'SAVE_REPORT_REQUEST',
    SAVE_REPORT_SUCCESS: 'SAVE_REPORT_SUCCESS',
    SAVE_REPORT_FAILED: 'SAVE_REPORT_FAILED',

    FETCH_REPORT_REQUEST: 'FETCH_REPORT_REQUEST',
    FETCH_REPORT_SUCCESS: 'FETCH_REPORT_SUCCESS',
    FETCH_REPORT_FAILED:  'FETCH_REPORT_FAILED',

    SET_REPORT_REQUEST: 'SET_REPORT_REQUEST',
    SET_REPORT_SUCCESS: 'SET_REPORT_SUCCESS',
    SET_REPORT_FAILED:  'SET_REPORT_FAILED',

    EDIT_REPORT_REQUEST: 'EDIT_REPORT_REQUEST',
    EDIT_REPORT_SUCCESS: 'EDIT_REPORT_SUCCESS',
    EDIT_REPORT_FAILED:  'EDIT_REPORT_FAILED',

    DELETE_REPORT_REQUEST: 'DELETE_REPORT_REQUEST',
    DELETE_REPORT_SUCCESS: 'DELETE_REPORT_SUCCESS',
    DELETE_REPORT_FAILED: 'DELETE_REPORT_FAILED',

    FETCH_SPECIES_REQUEST: 'FETCH_SPECIES_REQUEST',
    FETCH_SPECIES_SUCCESS: 'FETCH_SPECIES_SUCCESS',
    FETCH_SPECIES_FAILED:  'FETCH_SPECIES_FAILED',

    FETCH_HEALTHRATE_REQUEST: 'FETCH_HEALTHRATE_REQUEST',
    FETCH_HEALTHRATE_SUCCESS: 'FETCH_HEALTHRATE_SUCCESS',
    FETCH_HEALTHRATE_FAILED:  'FETCH_HEALTHRATE_FAILED',


    FETCH_RECOMENDATIONS_REQUEST: 'FETCH_RECOMENDATIONS_REQUEST',
    FETCH_RECOMENDATIONS_SUCCESS: 'FETCH_RECOMENDATIONS_SUCCESS',
    FETCH_RECOMENDATIONS_FAILED:  'FETCH_RECOMENDATIONS_FAILED',

    FETCH_TREE_REQUEST: 'FETCH_TREE_REQUEST',
    FETCH_TREE_SUCCESS: 'FETCH_TREE_SUCCESS',
    FETCH_TREE_FAILED:  'FETCH_TREE_FAILED',

    SAVE_TREE_REQUEST: 'SAVE_TREE_REQUEST',
    SAVE_TREE_SUCCESS: 'SAVE_TREE_SUCCESS',
    SAVE_TREE_FAILED:  'SAVE_TREE_FAILED',

    SET_TREE_REQUEST: 'SET_TREE_REQUEST',
    SET_TREE_SUCCESS: 'SET_TREE_SUCCESS',
    SET_TREE_FAILED:  'SET_TREE_FAILED',

    EDIT_TREE_REQUEST: 'EDIT_TREE_REQUEST',
    EDIT_TREE_SUCCESS: 'EDIT_TREE_SUCCESS',
    EDIT_TREE_FAILED:  'EDIT_TREE_FAILED',

    DELETE_TREE_REQUEST: 'DELETE_TREE_REQUEST',
    DELETE_TREE_SUCCESS: 'DELETE_TREE_SUCCESS',
    DELETE_TREE_FAILED:  'DELETE_TREE_FAILED',

    FETCH_ARBOR_REQUEST: 'FETCH_ARBOR_REQUEST',
    FETCH_ARBOR_SUCCESS: 'FETCH_ARBOR_SUCCESS',
    FETCH_ARBOR_FAILED: 'FETCH_ARBOR_FAILED',

    ADD_ARBOR_REQUEST: 'ADD_ARBOR_REQUEST',
    ADD_ARBOR_SUCCESS: 'ADD_ARBOR_SUCCESS',
    ADD_ARBOR_FAILED: 'ADD_ARBOR_FAILED',

    SET_ARBOR_REQUEST: 'SET_ARBOR_REQUEST',
    SET_ARBOR_SUCCESS: 'SET_ARBOR_SUCCESS',
    SET_ARBOR_FAILED: 'SET_ARBOR_FAILED',

    EDIT_ARBOR_REQUEST: 'EDIT_ARBOR_REQUEST',
    EDIT_ARBOR_SUCCESS: 'EDIT_ARBOR_SUCCESS',
    EDIT_ARBOR_FAILED: 'EDIT_ARBOR_FAILED',


    DELETE_ARBOR_REQUEST: 'DELETE_ARBOR_REQUEST',
    DELETE_ARBOR_SUCCESS: 'DELETE_ARBOR_SUCCESS',
    DELETE_ARBOR_FAILED: 'DELETE_ARBOR_FAILED',
    
    FETCH_JURISDICTION_REQUEST: 'FETCH_JURISDICTION_REQUEST',
    FETCH_JURISDICTION_SUCCESS: 'FETCH_JURISDICTION_SUCCESS',
    FETCH_JURISDICTION_FAILED: 'FETCH_JURISDICTION_FAILED',
}